import { ItemBadge } from "@coworker/apprestructured/src/shared/types/ItemBadge";
import React from "react";
import { MediaItemCardWithActions } from "@coworker/apprestructured/src/media-maintenance/components/item-cards/MediaItemCardWithActions/MediaItemCardWithActions";
import {
  Article,
  EdsData,
  SalesStopData,
} from "@coworker/app/src/components/RoomSettings/types/article";
import { useTranslation } from "@coworker/locales";
import { MediaItemType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemType";
import { MediaItemViewType } from "@coworker/apprestructured/src/media-maintenance/types/mediaItemViewType";
import { Item } from "@coworker/apprestructured/src/shared/types/item";
import { ItemCardRenderType } from "@coworker/apprestructured/src/shared/types/itemCardRenderType";

interface MediaItemCardLCSubItemProps {
  itemInfo: Item;
  edsData?: EdsData | null;
  salesStopData?: SalesStopData | null;
  article: Article;
  totalQuantityPieces?: number;
  shouldDisplayQuantity?: boolean;
  itemCardRenderType?: ItemCardRenderType;
  mediaItemViewType: MediaItemViewType;
}

export const MediaItemCardLCSubItem = ({
  itemInfo,
  salesStopData,
  article,
  edsData,
  totalQuantityPieces = 0,
  shouldDisplayQuantity = true,
  itemCardRenderType = ItemCardRenderType.link,
  mediaItemViewType = MediaItemViewType.SIMPLE_ITEM_VIEW,
}: MediaItemCardLCSubItemProps) => {
  const { t } = useTranslation();
  const itemBadges: ItemBadge[] = [];

  if (salesStopData) {
    itemBadges.push({
      text: t("salesStopString").toUpperCase(),
      colour: "red",
    });
  }

  return (
    <MediaItemCardWithActions
      mediaItemViewType={mediaItemViewType}
      edsData={edsData ?? null}
      item={itemInfo}
      badges={itemBadges || []}
      article={article}
      itemCardRenderType={itemCardRenderType}
      shouldDisplayQuantity={shouldDisplayQuantity}
      totalQuantityPieces={totalQuantityPieces}
      mediaItemType={MediaItemType.LC_SUBITEM}
      renderActions={() => null}
    />
  );
};
